//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from '../../../../../../_shared/animations';
import { RestResponse } from '../../../../../../_shared/models';
import { SettingsService } from '../../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'app-dunning-management',
  templateUrl: './dunning-management.component.html'
})

export class DunningManagementComponent implements OnInit, OnDestroy {
  resSuccess: boolean;
  dunningConfigAuto: any;
  dunningClycleAuto: Array<any> = [];
  isDunningClycleAutoReady: boolean = false;
  dunningCycleActionAuto: string;
  collectionOfDunningCycleAutoCounters: Array<number> = [];
  dunningConfigManual: any;
  dunningClycleManual: Array<any> = [];
  isDunningClycleManualReady: boolean = false;
  dunningCycleActionManual: string;
  collectionOfDunningCycleManualCounters: Array<number> = [];
  private subs = new Unsubscriber();

  constructor(
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-bullet', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-bullet-01.svg'));
    this._iconRegistry.addSvgIcon('ico-disabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-03.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));
    this._iconRegistry.addSvgIcon('ico-enabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-05.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-02.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-preview', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-wizard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-switch', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-loader', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-delete', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-02.svg'));
  }

  getDunningConfigs() {
    this.subs.addSub = this.settingsService.getDunningConfigs().subscribe(
      (res: any) => {
        if (res.data) {
          this.dunningConfigAuto = (res.data.dunningConfigAuto ? JSON.parse(res.data.dunningConfigAuto) : '');
          if (this.dunningConfigAuto) {
            this.dunningClycleAuto = this.dunningConfigAuto.dunningCycle;
            if(this.dunningClycleAuto.length > 0) {
              this.dunningClycleAuto.forEach((element, i) => {
                if (this.collectionOfDunningCycleAutoCounters.length === 0) {
                  this.collectionOfDunningCycleAutoCounters.push(parseInt(element.cycleFrec));
                } else {
                  this.collectionOfDunningCycleAutoCounters.push(parseInt(element.cycleFrec) + this.collectionOfDunningCycleAutoCounters[i-1]);
                }
              })
            }
            this.dunningCycleActionAuto = this.dunningConfigAuto.dunningCycleAction;
          }
          this.isDunningClycleAutoReady = true;

          this.dunningConfigManual = (res.data.dunningConfigManual ? JSON.parse(res.data.dunningConfigManual) : '');
          if (this.dunningConfigManual) {
            this.dunningClycleManual = this.dunningConfigManual.dunningCycle;
            if(this.dunningClycleManual.length > 0) {
              this.dunningClycleManual.forEach((element, i) => {
                if (this.collectionOfDunningCycleManualCounters.length === 0) {
                  this.collectionOfDunningCycleManualCounters.push(parseInt(element.cycleFrec));
                } else {
                  this.collectionOfDunningCycleManualCounters.push(parseInt(element.cycleFrec) + this.collectionOfDunningCycleManualCounters[i-1]);
                }
              })
            }
            this.dunningCycleActionManual = this.dunningConfigManual.dunningCycleAction;
          }
          this.isDunningClycleManualReady = true;
        }

        this.resSuccess = res.isSuccess;
      },
      (err: RestResponse) => {
        this.resSuccess = err.isSuccess;
        this.isDunningClycleManualReady = true;
        this.isDunningClycleAutoReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  ngOnInit() {
    this.getDunningConfigs();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
